// extracted by mini-css-extract-plugin
module.exports = {"container":"Ag","list":"Bg"};